import { HyperBackendMethod } from "@shared/backend/hyper-backend-method";
import { Roles } from "@shared/Roles";
import { Controller, remult, repo, type EntityFilter } from "remult";
import type { NotificationBase } from "../notification-base";
import { UserNotification } from "./entity";

@Controller("user-notification-methods")
export class UserNotificationMethods {
  @HyperBackendMethod({
    allowed: Roles.User,
    overrideSecurity: true,
  })
  static async markAsRead(where: EntityFilter<NotificationBase>) {
    await repo(UserNotification).updateMany({
      where: {
        $and: [
          {
            toId: remult.user!.id,
            hasRead: false,
          },
          where,
        ],
      },
      set: {
        hasRead: true,
      },
    });
  }
}
